const React = require("react");
const T = React.PropTypes;
const moment = require("moment");

require("./SurveyStatusList.less");

const auditTypes = require("~/config.js").AuditTypes;
const auditTypeNames = Object.keys(auditTypes);
const MetaAuditType = require("~/types/MetaAudit.js").PropType;
const SurveyStatusEntry = require("../SurveyStatusEntry/SurveyStatusEntry.jsx");

const periodSorter = (a, b) => {
    const aPair = a.split(' ');
    const bPair = b.split(' ');

    if (aPair[1] < bPair[1]) return 1;
    if (aPair[1] > bPair[1]) return -1;
    if (aPair[0] < bPair[0]) return 1;
    if (aPair[0] > bPair[0]) return -1;

    return 0;
};

const sorter = (a, b) => {
    const byPeriod = periodSorter(a.AuditPeriod, b.AuditPeriod);

    if (byPeriod !== 0) return byPeriod;

    const aTypeIndex = auditTypeNames.indexOf(a.AuditType);
    const bTypeIndex = auditTypeNames.indexOf(b.AuditType);

    if (aTypeIndex < bTypeIndex) return -1;
    if (aTypeIndex > bTypeIndex) return 1;

    if (a.PKID < b.PKID) return -1;
    if (a.PKID > b.PKID) return 1;

    return 0;
};

const SurveyStatusList = React.createClass({
    propTypes: {
        Data: T.arrayOf(MetaAuditType).isRequired
    },
    render() {
        const items = this.props.Data
            .sort(sorter)
            .map(this.AsItem);

        return (<ul className="cs-SurveyStatusList">
            {items}
        </ul>);
    },
    AsItem(s, i) {
        const className =
            (i % 2) === 0
            ? "cs-SurveyStatusList__ListItem"
            : "cs-SurveyStatusList__ListItem--odd";

        return (<li key={i} className={className}>
            <SurveyStatusEntry MetaAudit={s} />
        </li>);
    }
});

module.exports = SurveyStatusList; 


// WEBPACK FOOTER //
// ./src/components/SurveyStatusList/SurveyStatusList.jsx